import {
  User,
  TrendingUp,
  Building,
  Flag,
  DollarSign,
  Globe,
  CreditCard,
  Fingerprint,
  FileText,
  Landmark,
  Receipt,
  Plug,
  ScrollText,
  FileCheck2,
  FileSignature,
  MapPin,
  BadgeIndianRupee
} from 'lucide-react';

const loanRequirements = {
  "Personal Loan": {
    eligibilityCriteria: [
      {
        icon: "/assets/img/Layer_1 (11).png",
        title: "Age",
        value: "21 - 55 yrs"
      },
      {
        icon: "/assets/img/Layer_1 (12).png",
        title: "Credit Score",
        value: "> 659"
      },
      {
        icon: "/assets/img/Layer_1 (14).png",
        title: "Serviceable Area",
        value: "Metro Cities"
      },
      {
        icon: "/assets/img/Layer_1 (15).png",
        title: "Nationality",
        value: "Indian"
      },
      {
        icon: "/assets/img/Layer_1 (13).png",
        title: "Monthly Salary",
        value: "> 15,909"
      },
      {
        icon: "/assets/img/Layer_1 (16).png",
        title: "Mode",
        value: "Online"
      }
    ],
    documents: [
      {
        icon: <CreditCard className="w-5 h-5" />,
        title: "PAN Card"
      },
      {
        icon: <Fingerprint className="w-5 h-5" />,
        title: "Aadhaar Card"
      },
      {
        icon: <Plug className="w-5 h-5" />,
        title: "Electricity Bill"
      },
      {
        icon: <ScrollText className="w-5 h-5" />,
        title: "Last 3 Months Bank Statement"
      },
      {
        icon: <FileCheck2 className="w-5 h-5" />,
        title: "Last 3 Months Salary Slips"
      }
    ]
  },

  "Business Loan": {
    eligibilityCriteria: [
      {
        icon: "/assets/img/Layer_1 (11).png",
        title: "Age",
        value: "25 - 60 yrs"
      },
      {
        icon: "/assets/img/Layer_1 (12).png",
        title: "Credit Score",
        value: "> 790"
      },
      {
        icon: "/assets/img/Layer_1 (14).png",
        title: "Area",
        value: "Tier 1 & 2 Cities"
      },
      {
        icon: "/assets/img/Layer_1 (15).png",
        title: "Nationality",
        value: "Indian"
      },
      {
        icon: "/assets/img/Layer_1 (13).png",
        title: "Annual Turnover",
        value: "> ₹5 Lakhs"
      },
      {
        icon: "/assets/img/Layer_1 (16).png",
        title: "Mode",
        value: "Online/Offline"
      }
    ],
    documents: [
      {
        icon: <CreditCard className="w-5 h-5" />,
        title: "Business PAN Card"
      },
      {
        icon: <Fingerprint className="w-5 h-5" />,
        title: "Aadhaar Card of Owner"
      },
      {
        icon: <Plug className="w-5 h-5" />,
        title: "Utility Bill"
      },
      {
        icon: <ScrollText className="w-5 h-5" />,
        title: "6 Months Bank Statement"
      },
      {
        icon: <FileSignature className="w-5 h-5" />,
        title: "GST Returns"
      }
    ]
  },

  "PayOff": {
    eligibilityCriteria: [
      {
        icon: "/assets/img/Layer_1 (11).png",
        title: "Age",
        value: "21 - 69 yrs"
      },
      {
        icon: "/assets/img/Layer_1 (12).png",
        title: "Credit Score",
        value: "> 639"
      },
      {
        icon: "/assets/img/Layer_1 (14).png",
        title: "Area",
        value: "Pan India"
      },
      {
        icon: "/assets/img/Layer_1 (15).png",
        title: "Nationality",
        value: "Indian"
      },
      {
        icon: "/assets/img/Layer_1 (13).png",
        title: "Salary",
        value: "> ₹16,969"
      },
      {
        icon: "/assets/img/Layer_1 (16).png",
        title: "Mode",
        value: "Online"
      }
    ],
    documents: [
      {
        icon: <CreditCard className="w-5 h-5" />,
        title: "PAN Card"
      },
      {
        icon: <Fingerprint className="w-5 h-5" />,
        title: "Aadhaar Card"
      },
      {
        icon: <MapPin className="w-5 h-5" />,
        title: "Address Proof"
      },
      {
        icon: <ScrollText className="w-5 h-5" />,
        title: "Bank Statement"
      },
      {
        icon: <FileSignature className="w-5 h-5" />,
        title: "Existing Loan Statement"
      }
    ]
  }
};

export default loanRequirements;
